import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


function Sports() {
   const location = useLocation();
    
      // Scroll to the section if specified in the URL state
      useEffect(() => {
        if (location.state?.scrollTo) {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            // Use smooth scrolling to the section
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);
    return (
        <div>
                <div  className='ibdp-hero-sec'>
            <img src='newimg/Screenshot_24.webp'/>
    
          </div>
        <div className="sports-sec">
            <div className="sports-left-sec">
            <div className='cam-lower-sec'>
         <h1 className='title'>Sports Facilities at Sanskar School</h1>
      </div>
      <p>We at Sanskar encourage students to participate in sports activities for enjoyment, relaxation, and exercise. Sports are a positive aid to educational development and are imperative for the formation of a sense of self-worth in an individual. Sports also play a key role in building gamesmanship and team spirit. Every student is an ambassador of the true spirit of Sanskar – on and off the field. Students get an opportunity to experiment with a variety of sports that they wish to pursue, both to excel in or as a hobby.</p>
      <br/>
      <p><b>Sporting facilities include:</b></p>
      <br/>
      <h3>Outdoor</h3> 
      <ul className="sports-list">
        <li>Padle court</li>
        <li>Basketball synthetic court</li>
        <li>Tennis synthetic court </li>
        <li>Volleyball court </li>
        <li>Cricket ground </li>
        <li>Soccer ground</li>
        
        </ul> 
        <br />
        <h3>Indoor</h3> 
        <ul className="sports-list">
            <li>Badminton court</li>
            <li>Table tennis </li>
            <li>Yoga </li>
            <li>Skating </li>
            {/* <li>Aerobic and Gymnastics</li> */}
            <li>Taekwando and karate</li>
        </ul>
            </div>
            <div className="sports-right-sec">
                <div className="sports-img">
                    <img src="../newimg/competitive.webp" alt="" />

                </div>

            </div>
        </div>
        </div>
      )
    }

    export default Sports;
